module.exports = __webpack_public_path__ + "static/media/mockup-iphone.6851ad7b.png";